import { Injectable } from '@angular/core';
import { FeatureState } from '@modeso/aumico-lib-core-fe';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromConfigurationsActions from '../actions/configurations.actions';
import * as fromFeature from '../reducers/configurations.reducer';
import { IConfigurationsProvider } from './configurations.provider.interface';

@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class ConfigurationsProvider implements IConfigurationsProvider {
    constructor(private store: Store<FeatureState>) {}

    public isStorybook(): boolean {
        //This must always return false!
        return false;
    }

    public getSupportedLocales$(): Observable<string[]> {
        return this.store.pipe(select(fromFeature.SelectAllLocales));
    }

    public dispatchSupportedLocalesList(): void {
        this.store.dispatch(fromConfigurationsActions.configurationsActions.getSupportedLocales());
    }
}
